module.exports = __webpack_public_path__ + "img/xz.88d0c386.png";